export const depoimentsMoc = {
    title: 'Esse evento foi um divisor de águas na minha vida',
    videoIds: ['66577c8a82aa94000bcd3181', '66577c74b8f5ef000bb0eea5', '66577c5d82aa94000bcd3167'],
}
